/**
 * @govio/ui — design system compartilhado.
 *
 * Componentes shadcn/ui portados do snapshot Abacus (2026-05-06).
 * Stack: Tailwind 4, Radix UI primitives, lucide-react icons.
 */
export const UI_PACKAGE_VERSION = "0.1.0";

export { cn } from "./lib/utils";

export * from "./components/ui/button";
export * from "./components/ui/input";
export * from "./components/ui/label";
export * from "./components/ui/card";
export * from "./components/ui/badge";
export * from "./components/ui/separator";
export * from "./components/ui/skeleton";
export * from "./components/ui/textarea";
export * from "./components/ui/checkbox";
export * from "./components/ui/table";
export * from "./components/ui/dialog";
export * from "./components/ui/alert-dialog";
export * from "./components/ui/confirm-dialog";
export * from "./components/ui/dropdown-menu";
export * from "./components/ui/sheet";
export * from "./components/ui/tabs";
export * from "./components/ui/select";
export * from "./components/ui/toast";
